import { Details } from '../../gql/graphql';
import { OtherCharges } from '../../networkRequests/cart/updateOrderItems';
import { CartItemModel } from '../../state-machine/types/existingApplicationMachine.types';

export const getCartFromOrderDetails = (orderDetails?: Details): CartItemModel[] =>
  orderDetails?.items
    ?.filter((item) => item.displayName !== OtherCharges)
    .map((item, id) => ({
      itemName: item.displayName,
      quantity: item.quantity,
      price: (Math.round(parseFloat(item.price) * 100) * item.quantity) / 100,
      id: id,
    })) || [];
